/**
 * ShareButtons - Social sharing for product pages
 */

import type React from 'react';
import { useState } from 'react';

import * as styles from './ShareButtons.css';

interface ShareButtonsProps {
  url: string;
  title: string;
  image?: string;
}

export const ShareButtons: React.FC<ShareButtonsProps> = ({
  url,
  title,
  image,
}) => {
  const [copied, setCopied] = useState(false);

  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedImage = image ? encodeURIComponent(image) : '';

  const pinterestUrl = `https://pinterest.com/pin/create/button/?url=${encodedUrl}&description=${encodedTitle}${
    encodedImage ? `&media=${encodedImage}` : ''
  }`;
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;

  const handleCopyLink = async () => {
    if (typeof navigator === 'undefined' || !navigator.clipboard) {
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className={styles.container}>
      <span className={styles.label}>Share:</span>
      <a
        href={pinterestUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.button}
      >
        Pinterest
      </a>
      <a
        href={facebookUrl}
        target="_blank"
        rel="noopener noreferrer"
        className={styles.button}
      >
        Facebook
      </a>
      <button type="button" className={styles.button} onClick={handleCopyLink}>
        {copied ? 'Link copied!' : 'Copy link'}
      </button>
    </div>
  );
};
